import { render, staticRenderFns } from "./AMSProductImg.vue?vue&type=template&id=1c151958&scoped=true&"
import script from "./AMSProductImg.vue?vue&type=script&lang=ts&"
export * from "./AMSProductImg.vue?vue&type=script&lang=ts&"
import style0 from "./AMSProductImg.vue?vue&type=style&index=0&id=1c151958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c151958",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
